import { render, staticRenderFns } from "./CommitResult.vue?vue&type=template&id=52a1552c&scoped=true"
import script from "./CommitResult.vue?vue&type=script&lang=js"
export * from "./CommitResult.vue?vue&type=script&lang=js"
import style0 from "./CommitResult.vue?vue&type=style&index=0&id=52a1552c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a1552c",
  null
  
)

export default component.exports